import { useQuery } from "@tanstack/react-query";
import { getCurrentCaller, type Caller } from "./session";

export const CALLER_QUERY_KEY = ["auth", "caller"] as const;

// Small React hook over the ID-token claims. Wrapped in TanStack Query so
// every page can call it freely — a single request hits fetchAuthSession,
// and signIn/signOut invalidate the key to trigger refetch.
export function useCaller(): {
  caller: Caller | null;
  isLoading: boolean;
  isAuthenticated: boolean;
} {
  const { data, isLoading } = useQuery({
    queryKey: CALLER_QUERY_KEY,
    queryFn: getCurrentCaller,
    staleTime: 5 * 60_000,
    retry: false
  });

  return {
    caller: data ?? null,
    isLoading,
    isAuthenticated: !!data
  };
}
